import { FormInstance } from "antd";

import { SubOrderRequest } from "../../../../api";
import { useCampaign } from "../../../providers/CampaignProvider";
import { BudgetBonusFormSchema } from "../models";
import useFixedCostsSubOrderSettings from "../useFixedCostsSubOrderSettings";
import BudgetBonusFormSection from "./BudgetBonusFormSection";

const FixedCostsBudgetBonusFormSection = <T extends BudgetBonusFormSchema>({
  subOrder,
  form,
}: {
  subOrder: Partial<SubOrderRequest>;
  form: FormInstance<T>;
}) => {
  const { orderRequest } = useCampaign();

  // Validation rules
  const { createInstanceSettings: createInstanceContext } =
    useFixedCostsSubOrderSettings();

  // Get budget and bonus validation constraints from fixed costs sub order
  const fixedCostsSubOrder = createInstanceContext(subOrder);

  return (
    <BudgetBonusFormSection
      rules={fixedCostsSubOrder.validationConfigs}
      bonusEditable={!orderRequest?.bonusConfiguration?.bonusOnOrderRequest}
      budgetEditable
      form={form}
    />
  );
};

export default FixedCostsBudgetBonusFormSection;
